import {DischargeMethod} from '@hconnect/tuc-processes/fields/unloadingMethod/types'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {Typography, Box, FormControl, Select, MenuItem} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

type DischargeMethodSelectionProps = {
  value: DischargeMethod
  onChange: (method: DischargeMethod) => void
}

export const DischargeMethodSelection: React.FC<DischargeMethodSelectionProps> = ({
  value,
  onChange
}) => {
  const {t} = useTranslation()

  return (
    <Box sx={{mb: 3}}>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: '#52667a',
          marginBottom: '8px'
        }}
      >
        {t('orderIntake.rmc.steps.unloading.pumpConfiguration.dischargeMethod', 'Discharge method')}
      </Typography>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value as 'boom' | 'hose')}
          sx={{
            fontFamily: 'Inter',
            fontSize: '14px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #d1d9e0'
            },
            '& .MuiSelect-select': {
              padding: '12px 14px'
            }
          }}
          IconComponent={ExpandMoreIcon}
          data-test-id="discharge-method-select"
        >
          <MenuItem value="boom">
            {t('orderIntake.rmc.steps.unloading.pumpConfiguration.boom', 'Boom')}
          </MenuItem>
          <MenuItem value="hose">
            {t('orderIntake.rmc.steps.unloading.pumpConfiguration.hose', 'Hose')}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}
